import Mixpanel from 'mixpanel-browser';
import React, { FC } from 'react';
import RootNavigator from './navigation/RootNavigator';

import './App.css';

Mixpanel.init( '298481f5c0628915113eb49c99292c21', { debug: false, track_pageview: true, persistence: 'localStorage' } );

const App: FC = () => (
  <RootNavigator />
);

export default App;
